import React from 'react'
import './PrivacyPolicy.css'

const ShippingDelivery = () => {
  return (
    <div className='privacy-page'>

      <div className='privacy-hero'>
        <h1>Shipping &amp; Delivery Policy</h1>
        <p className='privacy-subtitle'>ArrAndArr — Shipping &amp; Delivery Policy</p>
        <p className='privacy-version'>July 2026 | Version 1.0</p>
      </div>

      <div className='privacy-content'>

        <section>
          <h2>Our Delivery Options</h2>
          <p>We want to make pet parenting as easy for you so that you can spend more quality time with your furry friends. See below for our delivery costs for your area:</p>
          <p>Courier deliveries take 2&ndash;5 working days depending on the order&rsquo;s destination.</p>

          <p><strong>Main Area Deliveries</strong></p>
          <ul>
            <li>Orders under R500: R55</li>
            <li>Orders over R500: <strong>FREE</strong></li>
          </ul>

          <p><strong>Regional Area Deliveries</strong></p>
          <ul>
            <li>Orders under R1,000: R85</li>
            <li>Orders over R1,000: <strong>FREE</strong></li>
          </ul>

          <p><strong>Outlying Area Deliveries</strong></p>
          <ul>
            <li>All orders: R85</li>
          </ul>
        </section>

        <section>
          <h2>Available Delivery Types</h2>
          <p>Depending on your delivery area, you will be able to select between the below delivery types:</p>

          <p><strong>Express Delivery</strong> &mdash; Next day delivery</p>
          <p><strong>Booked delivery</strong> &mdash; Option to choose specific delivery day based on your availability</p>
          <p><strong>Courier Delivery</strong> &mdash; Standard courier delivery in 1&ndash;7 working days depending on your area.</p>

          <p>For more information on delivery please contact our customer service by email to <a href="mailto:info@arrandarr.com">info@arrandarr.com</a>.</p>
        </section>

        <section>
          <h2>Delivery Times</h2>
          <p><strong>Mondays &ndash; Fridays:</strong> 08h00&ndash;17h00 (Excluding Public Holidays)</p>
          <p><strong>How long will my order take to arrive?</strong></p>
          <p>Courier deliveries take 2&ndash;5 working days depending on the order&rsquo;s destination.</p>
          <p>Orders eligible for express delivery will be delivered within 1 to 2 business days to main areas.</p>
          <p>Regional and outlying areas can expect a longer delivery time. This will be specified at checkout but can take up to 7 days.</p>
          <p>If there is an item in your order with an expected delay, this will be specified next to the item at checkout and on the product detail page and will delay your whole order.</p>
          <p>We share parcel tracking information as soon as the order is packed and ready to ship from our warehouse. Your delivery ETA can then be viewed at any point via &ldquo;Track My Order&rdquo;.</p>
        </section>

        <section>
          <h2>Returns Policy</h2>
          <p>If the Customer finds any product to be defective, the Customer may within 30 days of delivery of the product inform ArrAndArr of the defect via email and arrange to return the goods to the Company. Unfortunately we will not accept products which have been subjected to abuse, misuse, improper use, negligence, accident, alteration or tampering at the hands of the Customer.</p>
          <p>Orders placed incorrectly or in error by the Customer will need to be returned to the Company on the Customer&rsquo;s own account. No refunds will be made until the Goods are returned in good order to the specified location of the Company.</p>
          <p><strong>Note:</strong> A 2% transaction fee will be levied on returns of incorrect or mistakenly placed orders by the Customer.</p>
        </section>

        <section>
          <h2>Delayed Deliveries</h2>
          <p>From time to time we experience National Stock Shortages. This could be due to multiple reasons such as shortages of raw materials, delayed international shipments etc. Should a product you have ordered be:</p>
          <p><strong>Temporarily unavailable:</strong> We will notify you thereof as well as the anticipated delay in delivery (if possible) and, unless you agree to wait for such longer period for delivery, or accept delivery of another product instead, ArrAndArr will issue a refund in respect of that product to you or give you the option to credit your account to an amount equal to the price paid for the product*.</p>
          <p><strong>Discontinued / Permanently unavailable:</strong> We will notify you and, unless you agree to accept another product instead, ArrAndArr will issue a refund in respect of that product to you or give you the option to credit your account to an amount equal to the price paid for the product*.</p>
          <p className='privacy-version' style={{marginTop: 0}}>*Delivery fees will not be refunded if the unavailable item(s) are part of an order which included items that will still be delivered.</p>
          <p><strong>Areas not yet serviced:</strong> Should you wish to place an order but receive an error upon check out, this could be that your specific area has not yet been loaded for delivery on our system. Please contact support and we will try our best to set up a new courier delivery route to your area. Regrettably, this will not always be possible.</p>
        </section>

        <section>
          <h2>Cancellation Policy</h2>
          <p>The Electronic Communications and Transactions Act 25 of 2002 (&ldquo;ECT Act&rdquo;) entitles you to cancel your purchase within 7 days&rsquo; notice if the products you have purchased are not delivered within the agreed delivery period as specified in the our Delivery Policy. Certain items for sale on the website do have a lead time for delivery published on the product detail pages and need to be taken into account as part of our delivery policy.</p>
          <p>Should you choose to cancel an order which has not been received within our delivery times, items either need to be:</p>
          <ul>
            <li>not accepted and returned with the courier upon delivery; or</li>
            <li>if already received, returned to ArrAndArr in their original state.</li>
          </ul>
          <p>All order cancellations must be done by emailing <a href="mailto:info@arrandarr.com">info@arrandarr.com</a>. We will then refund you as per our Refund Policy.</p>
        </section>

      </div>

    </div>
  )
}

export default ShippingDelivery
